/**
 * i18n Setup
 *
 * Initializes internationalization with automatic browser language detection.
 * Supports German (de), French (fr), and English (en), defaulting to German.
 *
 * Language detection priority:
 * 1. Stored preference in localStorage (returning user)
 * 2. Browser language detection (new user)
 */

import i18n from 'i18next';
import { initReactI18next, useTranslation as useI18nTranslation } from 'react-i18next';
import de from './de.json';
import en from './en.json';
import fr from './fr.json';
import { getInitialLanguage, storeLanguage, isNewUser, type SupportedLanguage } from '@/utils/language';

// Get initial language with browser detection for new users
const getLanguageWithDetection = (): SupportedLanguage => {
  const initial = getInitialLanguage();

  // For new users, store the detected language
  if (isNewUser()) {
    storeLanguage(initial);
  }

  return initial;
};

void i18n.use(initReactI18next).init({
  resources: {
    de: { translation: de },
    en: { translation: en },
    fr: { translation: fr },
  },
  lng: getLanguageWithDetection(),
  fallbackLng: 'de',
  interpolation: { escapeValue: false },
});

export { useI18nTranslation as useTranslation };
export { useDocumentTitle } from './useDocumentTitle';
export default i18n;
